<template>
  <div
    class="mobile-menu"
    style="display: flex; gap: 10px; flex-direction: row"
  >
    <router-link :to="'/'" exact-active-class="active_link">
      <AppTitle :text="'Магистральная'" />
    </router-link>
    <router-link :to="'/gorbunova'" exact-active-class="active_link">
      <AppTitle :text="'Горбунова'" />
    </router-link>
    <router-link :to="'/calculator'" exact-active-class="active_link">
      <AppTitle :text="'Калькулятор'" />
    </router-link>
    <router-link :to="'/dispatcher'" exact-active-class="active_link">
      <AppTitle :text="'Диспетчер'" />
    </router-link>
    <router-link :to="'/tablo'" exact-active-class="active_link">
      <AppTitle :text="'Табло'" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "menu app",

  methods: {},
  mounted() {},
};
</script>

<style>
.active_link * {
  color: red !important;
}
@media (max-width: 768px) {
  .mobile-menu {
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
  }

  .mobile-menu::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }

  .mobile-menu a {
    flex: 0 0 auto;
  }
}
</style>
